import actionConst from '../constants/org-in-params.constants';

const defaultState = {
	modalVisible: false,
	docId: undefined,	
	orgId: undefined,
	inNumber: undefined,
	inDate: undefined,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.OPEN_ORG_PARAMS_MODAL: {
			return {
				...state,
				...action.payload,
				modalVisible: true,
			}
		}
		case actionConst.CLOSE_ORG_PARAMS_MODAL: {
			return {
				...state,
				modalVisible: false
			}
		}
		default:
			return state;
	}
}